import(/* webpackMode: "eager", webpackExports: ["PortfolioLayout"] */ "/app/src/components/Portfolio/PortfolioLayout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TangorPortfolioLayout"] */ "/app/src/features/tokenized-equity/components/portfolio/TangorPortfolioLayout.tsx");
